<template>
    <!--新增对话框-->
    <el-dialog
            title="发货"
            :visible.sync="dialogVisible"
            width="800px"
            :close-on-click-modal="false"
            :before-close="handleClose">

        <el-form :model="editForm" :rules="editFormRules" ref="editForm" label-width="100px" class="demo-editForm">

            <el-form-item label="收货用户名" prop="name" label-width="100px">
                <el-input v-model="editForm.name" autocomplete="off" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="手机号" prop="phone" label-width="100px">
                <el-input v-model="editForm.phone" autocomplete="off" :disabled="true"></el-input>
            </el-form-item>

            <el-form-item label="社区名称" prop="gradenName" label-width="100px" v-if="editForm.deliveryMethod ===2">
                <el-input v-model="editForm.gradenName" autocomplete="off" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="社区地址" prop="gradenAddress" label-width="100px" v-if="editForm.deliveryMethod ===2">
                <el-input v-model="editForm.gradenAddress" autocomplete="off" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="用户所在地区" prop="provinces" label-width="100px" v-if="editForm.deliveryMethod ===1">
                <el-input v-model="editForm.provinces" autocomplete="off" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="收货地址" prop="address" label-width="100px" v-if="editForm.deliveryMethod ===1">
                <el-input v-model="editForm.address" autocomplete="off" :disabled="true"></el-input>
            </el-form-item>
            <!-- <el-form-item label="快递单号" prop="courierNumber" label-width="100px">
                <el-input v-model="editForm.courierNumber" autocomplete="off"></el-input>
            </el-form-item> -->
            <el-form-item label-width="0">
                    <el-table
                    ref="multipleTable"
                    :data="tableData"
                    tooltip-effect="dark"
                    style="width: 100%"
                    border
                    stripe
                    @selection-change="handleSelectionChange">

                    <el-table-column
                            label="商品名称"
                            align="center"
                            prop="storeGoodsName"
                            width="300">
                    </el-table-column>
                    <el-table-column
                            label="商品封面"
                            align="center"
                            width="240">
                            <template slot-scope="scope">
                                <el-image
                                        style="width: 100px; height: 50px"
                                        :src="scope.row.storeGoodsCover"
                                        fit="scale-down"></el-image>
                            </template>
                    </el-table-column>
                    <el-table-column
                            label="数量"
                            align="center"
                            prop="shipmentQuantity"
                            width="219">
                    </el-table-column>
                </el-table>
            </el-form-item>
            <el-form-item  align="center">
                <el-button type="primary" @click="submitForm('editForm')" v-if="editForm.deliveryMethod ===1">发货</el-button>
                <el-button type="success" @click="submitForm('editForm')" v-else-if="editForm.deliveryMethod ===2">送达自提点</el-button>
            </el-form-item>
        </el-form>
    </el-dialog>
</template>

<script>

    export default {
        name: "AddUpdateBillApplyShipments",
        data(){
            return{
                isvideo: false,
                editForm:{},
                avatar:'',
                fileList:[],
                urlList:[],
                VideoList:[],
                tableData:[],
                multipleSelection:[],
                dialogVisible:false,
                    editFormRules: {
                    courierNumber: [
                        {required: true, message: '请输入快递单号', trigger: 'blur'}
                    ]
                },
            }
        },
        methods:{
            change(val) {
                this.editForm.content=val;
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
                this.dialogVisible = false
                this.editForm = {}
                this.tableData=[]
                this.multipleSelection=[]
                this.fileList=[];
                this.urlList=[]
                this.isvideo=false
                this.VideoList=[]
            },
            duration(playTime){
                console.log("122",playTime)
                this.editForm.videoTimeLong=parseInt(playTime)*1000
            },
            dataTypeChange(){
                if (this.editForm.dataType===1){
                    this.isvideo=true
                }else {
                    this.editForm.videoUrl==''
                    this.isvideo=false
                }
            },
             handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            handleClose() {
                this.resetForm('editForm')
            },
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.$axios.post('/admin/applyshipment/deliverGoods' , this.editForm)
                            .then(res => {

                                this.$message({
                                    showClose: true,
                                    message: '恭喜你，操作成功',
                                    type: 'success',
                                    onClose:() => {
                                        this.$emit('refreshDataList')
                                    }
                                });
                                this.dialogVisible = false
                                this.resetForm(formName)
                            })
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            getImgList(url,add) {
                if (add==1){
                    this.urlList.push(url)
                }else if (add==0){
                    if (this.urlList==null||this.urlList.length<1){
                        return;
                    }
                    this.urlList.some((item, i)=>{
                        if(item==url){
                            this.urlList.splice(i, 1)
                            //在数组的some方法中，若是return true，就会当即终止这个数组的后续循环
                            return true
                        }
                    })
                }
                this.editForm.goodsCover=this.urlList.join(",")
            },
            init(id){
                this.dialogVisible=true;
                if (id!=null&&id!=''&&id>0){
                    this.$axios.post('/admin/applyshipment/getApplyShipmentItem' ,{applyShipmentsId:id}).then(res => {
                        this.editForm = res.data
                        this.tableData = res.data.shipmentCartonsGoodsModelList

                    })
                }
            },
        }
    }
</script>

<style scoped>
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }
    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }
</style>
